import '.jq{background-position:0 -10px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import { Slider } from './Slider.js'
import type { RGB } from './utils.js'
import { transparent } from './bg.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { styled, Style } from 'inlines'

export const AlphaSlider = ({
  rgb,
  alpha,
  onChange,
  style,
}: {
  rgb: RGB
  alpha: number
  onChange: (alpha: number) => void
  style?: Style
}) => {
  const rgbString = rgb.join(',')
  return (
    <div className="jq h"
      style={{
        background: transparent,
        border: `1px solid ${colors.neutral20Adjusted}`,
        borderRadius: radius[8],}}
    >
      <Slider
        value={alpha}
        max={1}
        step={0.01}
        onChange={onChange}
        style={{
          background: `linear-gradient(to right, rgba(${rgbString}, 0) 0%, rgb(${rgbString}) 100%)`,
          ...style,
        }}
      />
    </div>
  )
}
